import React from 'react'

import SideNavLink from '../ui/sideNavLink'
import { ReactComponent as ChatIcon } from '../../static/images/feedback-chat.svg'
import FeedbackModal from './FeedbackModal'
import './styles.scss'

const FeedbackNavLink: React.FC = () => {
  const [modalOpen, setModalOpen] = React.useState(false)

  return (
    <>
      <SideNavLink
        onClick={() => setModalOpen(true)}
        icon={<ChatIcon />}
      >
        Any Feedback?
      </SideNavLink>
      <FeedbackModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSubmitted={() => {}}
      />
    </>
  )
}

export default FeedbackNavLink
